<app-form-generator
    [formId]="formId"
    [formData]="formData"
    [emitFormDataTrigger]="getFormData"
    (emitFormData)="formDataEmitted($event)"
    (emitFormStatus)="formStatusUpdated($event)"
></app-form-generator>

<div class="integration-form-footer">
    <button
        *ngIf="isCreateMode"
        mat-stroked-button
        appPreventDoubleClick (throttledClick)="cancelled.emit()"
    >{{ 'Cancel' | translate: {Default: "Cancel"} }}</button>

    <button
        mat-flat-button
        setColor="primaryColour"
        color="primary"
        appPreventDoubleClick (throttledClick)="getFormData = !getFormData"
        [disabled]="!formValid"
    >
        <ng-container *ngIf="isCreateMode; else saveLabel">{{ 'Integrations-CreateButton' | translate: {Default: "Create Integration"} }}</ng-container>
        <ng-template #saveLabel>{{ 'Save' | translate: {Default: "Save"} }}</ng-template>
    </button>
</div>
